export default __webpack_public_path__ + "static/media/main.442cc37c.png";